import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "axios"

export const handleGetSyncDataSingle = createAsyncThunk(
  "data/fetchData",
  async (payload) => {
    const response = await axios.post("/Home/SyncAllData", {
      PhlebotomistID: payload?.PhlebotomistID,
      PreBookingID: payload?.PreBookingID,
      type: "3",
    });
    console.log(response.data);
    return response.data;
  }
);

const initialState = {
  error: false,
  loading: false,
  success: false,
  data: {},
};

export const getSyncSingleData = createSlice({
  name: "SyncSingleData",
  initialState: initialState,
  extraReducers: (builder) => {
    builder.addCase(handleGetSyncDataSingle.pending, (state, action) => {
      state.data = {};
      state.loading = true;
    });
    builder.addCase(handleGetSyncDataSingle.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload;
    });
    builder.addCase(handleGetSyncDataSingle.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

// this is for dispatch
export const { SyncSingleData } = getSyncSingleData.actions;

// this is for configureStore
export default getSyncSingleData.reducer;
